








import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component({})
export default class CCategoryPackageText extends Vue {
    @Prop({
        default: "",
        type: String,
    })
    public displayText!: string;

    public isExpanded = false;

    public textClicked() {
        this.isExpanded = !this.isExpanded;
    }
}
